<template>
  <path pid="0" d="M13 2a11 11 0 1011 11A11 11 0 0013 2zm0 20a9 9 0 119-9 9 9 0 01-9 9z"/><circle pid="1" cx="13" cy="16" r="1"/><path pid="2" d="M13 8a1 1 0 00-1 1v4a1 1 0 002 0V9a1 1 0 00-1-1z"/>
</template>
